import React, { useEffect, useState } from 'react';

export default function InfoPage03(props) {
  const [age, setAge] = useState(undefined);
  const [gender, setGender] = useState(undefined);
  const [gender_text, setGenderText] = useState(undefined);
  const [corrected_vision, setCorrectedVision] = useState(undefined);
  const [visualization_experience, setVisualizationExperience] = useState(undefined);
  const [academic_status, setAcademicStatus] = useState(undefined);
  const [study, setStudy] = useState(undefined);
  const [gender_textarea, setGenderTextarea] = useState([]);


  const handleChange = (event) => {
    switch(event.target.name) {
      case 'age':
        setAge(event.target.value);
        break;
      case 'gender':
        setGender(event.target.value);
        break;
      case 'gender_text':
        setGenderText(event.target.value);
        break;
      case 'corrected_vision':
        setCorrectedVision(event.target.value);
        break;      
      case 'academic_status':
        setAcademicStatus(event.target.value);
        break;
      case 'study':
        setStudy(event.target.value);
        break;  
      case 'visualization_experience':
        setVisualizationExperience(event.target.value);
        break;
      default:
        console.log('Error Updating '+event.target.name)
      }
  }

  useEffect(() => {
    let tmp = []
    if(gender === 'gender_text'){
      tmp.push(
        <div>
          <br /><br />
          <div className="form-group">
            <label htmlFor="gender_text">Gender Self-Identification</label>
            <input type="text" className="form-control" name="gender_text" id="gender_text" placeholder="enter gender 🏳️‍🌈" value={gender_text} onChange={handleChange.bind(this)}/>
          </div>
        </div>
      )
    }
    setGenderTextarea(tmp)
  },[gender])

  return (
    <div>
      <h2>Participant Demographics</h2>
      
      <p>Please answer the following questions.</p>

      <label htmlFor="age">What is your age?</label>
      <br />
      <input type="text" className="form-control" placeholder="your age" aria-label="your age" aria-describedby="basic-addon1" name="age" id="age" value={age} onChange={handleChange.bind(this)}/>

      <br /><br />

      <label htmlFor="gender">What is your gender?</label>
      <br />
      <select className="form-control" name="gender" id="gender" value={gender} onChange={handleChange.bind(this)}>
        <option value="gender_null"></option>
        <option value="gender_m">Man</option>
        <option value="gender_w">Woman</option>
        <option value="gender_x">Nonbinary or Genderqueer</option>
        <option value="gender_text">Prefer to self identify</option>
        <option value="gender_no">Prefer not to say</option>
      </select>

      {gender_textarea}

      <br /><br />

      <label htmlFor="corrected_vision">Do you have corrected vision? (glasses or contact lenses)</label>
      <br />
      <select className="form-control" name="corrected_vision" id="corrected_vision" value={corrected_vision} onChange={handleChange.bind(this)}>
        <option value="corrected_null"></option>
        <option value="corrected_y">Yes</option>
        <option value="corrected_n">No</option>
      </select>

      <br /><br />

      <label htmlFor="visualization_experience">How much experience do you have creating or using data visualizations?</label>
      <br />
      <select className="form-control" name="visualization_experience" id="visualization_experience" value={visualization_experience} onChange={handleChange.bind(this)}>
        <option value="experience_null"></option>
        <option value="experience_01">No Experience</option>
        <option value="experience_02">Little Experience</option>
        <option value="experience_03">Some Experience</option>
        <option value="experience_04">Casual Experience</option>
        <option value="experience_05">Extensive Experience</option>
      </select>

      <br /><br />

      <label htmlFor="study">What is your field of study</label>
      <br />
      <input type="text" className="form-control" placeholder="Field of study" aria-label="Field of study" name="study" id="study" value={study} onChange={handleChange.bind(this)}/>

      <br /><br />

      <label htmlFor="academic_status">What is your status at UNC-Chapel Hill?</label>
      <br />
      <select className="form-control" name="academic_status" id="academic_status" value={academic_status} onChange={handleChange.bind(this)}>
        <option value="academic_null"></option>
        <option value="academic_student">Student</option>
        <option value="academic_faculty">Faculty</option>
        <option value="academic_faculty">Staff</option>
        <option value="academic_faculty">Other</option>
      </select>

      <br /><br />

      <div className="text-center">
        <button 
          style={{ marginTop: '25px', width: '150px' }} 
          className="btn btn-outline-primary" 
          onClick={(e) => {
            let responses = {
              'id': 'demographics',
              'age': age,
              'gender': gender,
              'gender_text': gender_text,
              'corrected_vision': corrected_vision,
              'visualization_experience': visualization_experience,
              'study': study,
              'academic_status': academic_status
            }
            setAge(undefined);
            setGender(undefined);
            setGenderText(undefined);
            setCorrectedVision(undefined);
            setVisualizationExperience(undefined);
            setAcademicStatus(undefined);
            setStudy(undefined);
            setGenderTextarea([]);
          
            props.next(responses)
          }}>Next</button>
      </div>
    </div>
  );
}
